module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABNklEQVR4AeyYwU3DMBSGfzvhgNq06YGWIyPQDRihK7ABmzACIwATwAZlBAYoSlonoi2VHvbxyRbv0BC3ki09te93kvflS07RsKuqvm/qZvtWm21lf6n3anfPjsGiQLs/KldL29xBoUSMRbRQF2rpWLTK9SNigfCbLy3Uk4aiBc+jdrc66nh/eHlqQEhA/lPiSTLEffhdMuQ74UkyxH34XTLkO+GJaKhtG3ytVp2UMYZPD3Qi0Ga9xn6/66Qaswkg8EgEKooCeZ4jy7KjazQe8+mBTgcyFg2LEa6mM0xn10fXYDBk1w41IlDopP/MEpBkNxlKhiQD0v5ZvkPSTXW6nwxJOk/SUC1R97nvDH30OfCvWUR41fRD9/ag+JYINQ70oCeTy08LNbcfrV4QYzkQ4J0ONHcsvwAAAP//GzU7bwAAAAZJREFUAwBu2x8CzxNePQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shuliang_-@2x.png
// module id = 891
// module chunks = 1